
import React from 'react';
import Icon from './index';

const vectors = 'M6.16666667,4.5 L17.8333333,4.5 C18.7538079,4.5 19.5,5.24619208 19.5,6.16666667 L19.5,17.8333333 C19.5,18.7538079 18.7538079,19.5 17.8333333,19.5 L6.16666667,19.5 C5.24619208,19.5 4.5,18.7538079 4.5,17.8333333 L4.5,6.16666667 C4.5,5.25 5.25,4.5 6.16666667,4.5 Z M6.16666667,6.16666667 L6.16666667,17.8333333 L17.8333333,17.8333333 L17.8333333,6.16666667 L6.16666667,6.16666667 Z';

export default function CheckboxUncheck(props) {
  return (
    <Icon {...props} viewBox="0 0 24 24" vectors={vectors} />
  );
}
